<template>
  <div class="o-modal" @click="$store.commit(action, false)">
    <div class="o-modal__header">
      <button class="c-mobile-btn c-mobile-btn--modal" @click="$store.commit(action, false)">
        <span class="c-mobile-btn__icon"><svg class="c-icon c-icon--cross"><use xlink:href="#icon-cross"></use></svg></span>
        <span class="c-mobile-btn__text">Close</span>
      </button>
    </div>
    <div class="o-modal__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyModal',
  props: {
    action: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyModal.vue